import type { Vehicle } from "@b2bportal/ground-api";
import type { RoomInfo, RoomProduct } from "@b2bportal/lodging-api";

export enum ChosenProduct {
  ChosenFlight = "ChosenFlight",
  ChosenLodging = "ChosenLodging",
  ChosenCar = "ChosenCar",
}

export interface ChosenFlight {
  ChosenProduct: ChosenProduct.ChosenFlight;
  tripId: string;
  fareId: string;
  outbound: {
    arrival: string;
    departure: string;
    flightNumber: string;
    marketingAirline: string;
    operatingAirline: string;
    origin: string;
    stops: number;
    totalDurationMinutes: number;
  };
  returning?: {
    arrival: string;
    departure: string;
    flightNumber: string;
    marketingAirline: string;
    operatingAirline: string;
    origin: string;
    stops: number;
    totalDurationMinutes: number;
  };
}

export interface ChosenLodging {
  ChosenProduct: ChosenProduct.ChosenLodging;
  lodgingId: string;
  roomInfoProducts: {
    product: RoomProduct;
    roomInfo: RoomInfo;
  };
  stayDates: {
    from: string;
    until: string;
  };
}

export interface ChosenCar {
  ChosenProduct: ChosenProduct.ChosenCar;
  uasUnlimitedMileage: boolean;
  supplierName: string;
  vehicle: Vehicle;
  pickupLocationName: string;
  pickupDateTime: string;
  dropoffDateTime: string;
}

export interface ChosenProductsResponse {
  chosenProducts: (ChosenFlight | ChosenLodging | ChosenCar)[];
}
